'use strict';

var ReactNativeFile = require('./ReactNativeFile');

module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-files/public/isExtractableFile.js
// module id = 1612
// module chunks = 11